// src/api/socket.js
import { io } from "socket.io-client";
import { API_BASE } from "./index";

let socket = null;
let connectPromise = null;
let queued = [];
let lastUserId = null;

export function connectSocket(userId) {
  if (!userId) return;

  const uid = String(userId);

  // same user & already connecting/connected
  if (socket && socket.connected && lastUserId === uid) return socket;
  if (connectPromise && lastUserId === uid) return connectPromise;

  if (socket) {
    try { socket.disconnect(); } catch {}
    socket = null;
  }
  lastUserId = uid;

  connectPromise = new Promise((resolve) => {
    socket = io(API_BASE, {
      transports: ["websocket", "polling"],
      reconnection: true,
      reconnectionDelay: 1000,
      reconnectionDelayMax: 5000,
      timeout: 10000,
      query: { userId: uid },
    });

    const flush = () => {
      if (queued.length) {
        queued.forEach(({ evt, payload, ack }) => {
          try { socket.emit(evt, payload, ack); } catch {}
        });
        queued = [];
      }
    };

    socket.on("connect", () => {
      flush();
      resolve(socket);
    });

    socket.on("disconnect", () => {});
    socket.on("connect_error", (e) => {
      console.warn("[socket connect_error]", e?.message || e);
      // keep waiting for future successful connect
    });
  });

  return connectPromise;
}

export function getSocket() {
  return socket;
}

export async function safeEmit(evt, payload) {
  const s = getSocket();
  if (s && s.connected) {
    s.emit(evt, payload);
    return;
  }
  queued.push({ evt, payload });
  if (!connectPromise && lastUserId) {
    try { connectSocket(lastUserId); } catch {}
  }
  try { await connectPromise; } catch {}
}
